import { useState } from "react";
import { ButtonGroupDataType } from "../../interfaces/buttonGroup/ButtonGroup.type";
import styles from "./ButtonGroupContainer.module.css";
import { generateStyleClasses, styleHelper } from "../../helpers/commonFunctions";
export default function ButtonGroupContainer({
  items,
}: {
  items: ButtonGroupDataType[];
}) {
  const [isLoading, setIsLoading] = useState(false);
  const item = items[0];

  const onClickHandler = async (link: string) => {
    if (isLoading) return;
    try {
      setIsLoading(true);
      window.location.href = link;
      // setIsDisabled(true);
      //   await continueDraft();
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
      // setIsDisabled(false);
    }
  };
  return (
    <div className="vas-w-100 vas-px-3 vas-text-center vas-align-items-start">
      {item?.buttonList?.map((button, idx) => {
        return (
          <button
            key={idx}
            className={`vas-btn vas-d-block  vas-text-center vas-btn-lg vas-mb-2 vas-p-2 vas-border-radius 
            ${generateStyleClasses(button?.style)} ${styles.single_btn}`}
            style={styleHelper({
              borderColor: button?.borderColor,
              backgroundColor: button?.backgroundColor,
              color: button?.textColor,
            })}
            onClick={() => onClickHandler(button?.deeplink)}
          >
            {button?.text}
          </button>
        );
      })}
    </div>
  );
}
